import { render } from "./home.vue?vue&type=template&id=5c29c44a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=5c29c44a&lang=scss&scoped=true"

import exportComponent from "/Users/waiting/Desktop/代码库/musich5/代码/musicweapons/frontend/music/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c29c44a"]])

export default __exports__